import React, { useState } from "react";
import BuildProfileLayout from "../../components/BuildProfile/BuildProfileLayout";
import BuildProfileMain from "../../components/BuildProfile/BuildProfileMain";
import { useLocation } from "react-router-dom";
import { VIEW_PROFILE } from "../../query/ViewProfile";
import { hasuraClient } from "../../apolloClient";
import { useLazyQuery } from "@apollo/client";

const BuildProfileContainer = () => {
  const [userData, setUserData] = useState(null);

  const [profileData] = useLazyQuery(VIEW_PROFILE, {
    notifyOnNetworkStatusChange: "true",
    fetchPolicy: "network-only",
    client: hasuraClient,
    onCompleted: (data) => {
      setUserData(data);
    },
  });

  React.useEffect(() => {
    profileData();
  }, []);

  const { state } = useLocation();

  return (
    <BuildProfileLayout>
      <BuildProfileMain state={state} name={userData?.users[0]?.full_name} />
    </BuildProfileLayout>
  );
};

export default BuildProfileContainer;
